module.exports = __webpack_public_path__ + "static/media/usa.3476c51e.svg";